<template>
  <div>
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/list-query/singleTab/item-list' }"
          >功能样例</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/list-query/singleTab/item-list' }"
          >单表增删改查</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          <span>编辑</span>
          <span class="ccui-curr-crumb ccui-ml-10" v-if="formOrigin">
            {{ formOrigin.userName }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container-detail-body">
        <el-group-title title="人员信息">
          <template slot="groupTitle">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-width="160px"
              class="ccui-form"
            >
              <el-form-item label="姓名：" prop="userName">
                <el-input
                  v-model="form.userName"
                  class="ccui-form-shortInput"
                  placeholder="请输入姓名"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
              <el-form-item label="性别：" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  type="date"
                  placeholder="请选择出生日期"
                  v-model="form.birthday"
                  style="width:160px"
                  value-format="yyyy-MM-dd"
                  clearable
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="政治面貌：" prop="politicalOutlook">
                <el-select
                  v-model="politicalOutlook"
                  class="ccui-form-longInput"
                  placeholder="请选择政治面貌"
                  value
                >
                  <el-option label="群众" value="1"></el-option>
                  <el-option label="团员" value="2"></el-option>
                  <el-option label="党员" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工龄：" prop="workYears">
                <el-input-number
                  size="small"
                  v-model="form.workYears"
                  :min="0"
                  :max="65"
                  :step="1"
                  step-strictly
                ></el-input-number>
              </el-form-item>
              <el-form-item label="是否已婚：">
                <el-switch
                  v-model="form.isMarried"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  width="50"
                  class="ccui-form-switch"
                  @change="changeSwitch"
                ></el-switch>
              </el-form-item>
              <el-form-item label="年收入：" prop="annualIncome">
                <el-input
                  v-model.trim="form.annualIncome"
                  placeholder="请输入年收入"
                  class="ccui-form-shortInput"
                  clearable
                  maxLength="11"
                >
                  <span slot="prefix" style="color:#4A4A4A">¥</span>
                </el-input>
              </el-form-item>
              <el-form-item prop="idNum" label="身份证号：">
                <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  class="ccui-form-longInput"
                  v-model="form.idNum"
                  @input="
                    value => {
                      form.idNum = value.replace(/[^\dXx]/g, '');
                    }
                  "
                  maxlength="18"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="userMobile" label="手机号：">
                <el-input
                  type="text"
                  placeholder="请输入手机号"
                  class="ccui-form-longInput"
                  v-model="form.userMobile"
                  @input="
                    value => {
                      form.userMobile = value.replace(/[^\d]/g, '');
                    }
                  "
                  maxlength="11"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="爱好：" prop="hobby">
                <el-checkbox-group v-model="hobbyList">
                  <el-checkbox
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in hobbyListArray"
                    :key="index"
                    >{{ item.value }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <el-form-item
                label="备注："
                prop="remarks"
                style="width:500px;height:120px"
                class="ccui-form-textArea"
              >
                <el-input
                  type="textarea"
                  placeholder="请输入"
                  v-model="form.remarks"
                  maxlength="500"
                  show-word-limit
                  style="width:500px;height:120px"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-group-title>
        <!-- <div class="ccui-top-title">人员信息</div> -->
      </div>
    </div>
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
        <div class="ccui-bottom-guide-divider" />
        <li>
          <el-button
            type="bottom"
            icon="icon-ccui-save"
            @click="submitHandle('form')"
            >保存</el-button
          >
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle"
            >取消</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import { getUserDemoById, editDemoUser } from "../api/item-list";
import validators from "@/basa/utils/validators";
import { getSessionItem } from "@/basa/utils";
export default {
  name: "listquery-edit-item",
  data() {
    return {
      title: "编辑信息",
      // agentId: window.location.href
      //   .split("?")[1]
      //   .split("/")[0]
      //   .split("=")[1]
      //   .replace("#", ""),
      submitFlag: false,
      form: {
        id: "",
        userName: "",
        birthday: "",
        politicalOutlook: "",
        isMarried: "1",
        annualIncome: "",
        idNum: "",
        userMobile: "",
        remarks: "",
        workYears: "0"
      },
      politicalOutlook: "",
      formatterList: {
        handleOutlook(row) {
          switch (row) {
            case 1:
              return "群众";
            case 2:
              return "团员";
            case 3:
              return "党员";
          }
        },
        handleOutlookFinal(row) {
          switch (row) {
            case "群众":
              return 1;
            case "团员":
              return 2;
            case "党员":
              return 3;
          }
        }
        // ismarriedHandler(row, col) {
        //   switch (row.isMarried) {
        //     case 0:
        //       return "未婚";
        //     case 1:
        //       return "已婚";
        //   }
        // }
      },
      hobbyList: [],
      formOrigin: {},
      hobbyListOrigin: [],
      politicalOutlookOrigin: "",
      hobbyListArray: [
        {
          value: "篮球",
          label: "1"
        },
        {
          value: "足球",
          label: "2"
        },
        {
          value: "排球",
          label: "3"
        },
        {
          value: "乒乓球",
          label: "4"
        },
        {
          value: "羽毛球",
          label: "5"
        },
        {
          value: "网球",
          label: "6"
        },
        {
          value: "钢琴",
          label: "7"
        },
        {
          value: "舞蹈",
          label: "8"
        },
        {
          value: "绘画",
          label: "9"
        },
        {
          value: "书法",
          label: "10"
        }
      ],
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            validator: validators.userName,
            message: "请输入正确格式的姓名",
            trigger: "change"
          }
        ],
        userMobile: [
          { message: "请输入手机号", trigger: "change" },
          {
            validator: validators.userMobile,
            message: "请输入正确格式的手机号",
            trigger: "change"
          }
        ],
        annualIncome: [
          {
            validator: validators.money,
            message: "请输入正确金额格式(最多8位整数或8位整数和两位小数)",
            trigger: "change"
          }
        ],
        idNum: [
          {
            validator: validators.identification,
            message: "请输入正确的身份证号码",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    const id = this.$route.params.id;
    this.getListDetail(id);
  },
  methods: {
    // 更改婚姻状况
    changeSwitch(value) {
      this.form.isMarried = value;
    },
    // 重置取消
    resetHandle() {
      this.getListDetail(this.$route.params.id);
    },
    // 保存校验
    submitHandle(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editPeople();
        } else {
          this.errorLocation(this);
          return false;
        }
      });
    },
    // 编辑保存请求
    editPeople() {
      // 这里要加trim去掉字符串首尾空格
      let politicalOutlook = this.politicalOutlook;
      if (
        politicalOutlook == "群众" ||
        politicalOutlook == "团员" ||
        politicalOutlook == "党员"
      ) {
        politicalOutlook = this.formatterList.handleOutlookFinal(
          politicalOutlook
        );
      }
      const obj = {
        id: this.form.id,
        userName: this.form.userName ? this.form.userName.trim() : undefined,
        sex: this.form.sex ? Number(this.form.sex) : undefined,
        birthday: this.form.birthday ? this.form.birthday : undefined,
        politicalOutlook: politicalOutlook
          ? Number(politicalOutlook)
          : undefined,
        workYears: this.form.workYears != 0 ? this.form.workYears : undefined,
        isMarried: Number(this.form.isMarried),
        annualIncome: this.form.annualIncome
          ? Number(this.form.annualIncome)
          : undefined,
        idNum: this.form.idNum ? this.form.idNum.trim() : undefined,
        userMobile: this.form.userMobile
          ? this.form.userMobile.trim()
          : undefined,
        hobby: this.hobbyList.length ? this.hobbyList.join(",").trim() : "",
        remarks: this.form.remarks ? this.form.remarks : undefined,
        isShowLoading: true,
        loadingMessage: "保存中,请稍等..."
      };
      editDemoUser(obj)
        .then(res => {
          if (res.data.code === "0") {
            this.$message({
              message: "编辑成功",
              type: "success",
              duration: 1000,
              showClose: true,
              ccuiCustom: true
            });
            this.submitFlag = true;
            this.$router.back(-1);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    //详情请求
    getListDetail(id) {
      const obj = {
        id: id,
        isShowPageLoading: true
      };
      getUserDemoById(obj)
        .then(res => {
          if (res.data.code == "0") {
            this.form = res.data.data;
            this.form.id = Number(id);
            this.politicalOutlook = this.form.politicalOutlook
              ? this.formatterList.handleOutlook(this.form.politicalOutlook)
              : "";
            this.form.birthday = this.form.birthday
              ? this.form.birthday.substr(0, 10)
              : "";
            this.hobbyList =
              this.form.hobby === "" ? [] : this.form.hobby.split(",");
            this.formOrigin = JSON.parse(JSON.stringify(this.form));
            this.hobbyListOrigin = this.hobbyList
              ? JSON.parse(JSON.stringify(this.hobbyList))
              : "";
            this.politicalOutlookOrigin = this.politicalOutlook
              ? JSON.parse(JSON.stringify(this.politicalOutlook))
              : "";
            this.form.remarks = this.form.remarks ? res.data.data.remarks : "";
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 返回
    handleBack() {
      this.$router.push("/list-query/singleTab/item-list");
    }
  },
  computed: {
    // 获取面包屑
    getBreadcrumb() {
      return getSessionItem("breadcrumb");
    }
  }
  // 更改列表缓存状态
  // beforeRouteLeave(to, from, next) {
  //   if (this.submitFlag === true) {
  //     for (var key in this.$vnode.parent.componentInstance.cache) {
  //       delete this.$vnode.parent.componentInstance.cache[
  //         ishasAgentId(to.path, key)
  //       ];
  //     }
  //   }
  //   next();
  // }
};
</script>
